// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PermissionsRequestsToast__event-be2b4c {
  position: absolute;
  bottom: 16px;
  inset-inline-start: 16px;
  display: inline-flex;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 4px;
  background-color: var(--base-100);
  z-index: 5;
  min-height: 48px;
  width: 312px;
}

.PermissionsRequestsToast__event-text-bf4df1 {
  word-break: break-word;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-0);
  max-width: 220px;
}

.PermissionsRequestsToast__event-button-aa686e {
  background: transparent;
  font: var(--font-button);
  padding: 7px 12px 7px 12px;
  color: var(--base-0);
  cursor: pointer;
  margin-inline-start: auto;
}

.PermissionsRequestsToast__enter-bbc6a3 {
  opacity: 0;
  margin-top: -30px;
}

.PermissionsRequestsToast__enter-active-cb059a {
  opacity: 1;
  margin-top: 0;
  transition: opacity 250ms linear, margin-top 250ms linear;
}

.PermissionsRequestsToast__exit-db98c2 {
  opacity: 1;
}

.PermissionsRequestsToast__exit-active-b133a3 {
  opacity: 0;
  transition: opacity 250ms linear;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/PermissionsRequestsToast/PermissionsRequestsToast.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AACA;EACE,UAAA;EACA,iBAAA;AAEF;;AACA;EACE,UAAA;EACA,aAAA;EACA,yDAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,UAAA;EACA,gCAAA;AAEF","sourcesContent":[".event {\n  position: absolute;\n  bottom: 16px;\n  inset-inline-start: 16px;\n  display: inline-flex;\n  border-radius: 12px;\n  box-sizing: border-box;\n  padding: 6px 12px;\n  align-items: center;\n  margin-bottom: 4px;\n  background-color: var(--base-100);\n  z-index: 5;\n  min-height: 48px;\n  width: 312px;\n}\n\n.event-text {\n  word-break: break-word;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-0);\n  max-width: 220px;\n}\n\n.event-button {\n  background: transparent;\n  font: var(--font-button);\n  padding: 7px 12px 7px 12px;\n  color: var(--base-0);\n  cursor: pointer;\n  margin-inline-start: auto;\n}\n.enter {\n  opacity: 0;\n  margin-top: -30px;\n}\n\n.enter-active {\n  opacity: 1;\n  margin-top: 0;\n  transition: opacity 250ms linear, margin-top 250ms linear;\n}\n\n.exit {\n  opacity: 1;\n}\n\n.exit-active {\n  opacity: 0;\n  transition: opacity 250ms linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"event": `PermissionsRequestsToast__event-be2b4c`,
	"event-text": `PermissionsRequestsToast__event-text-bf4df1`,
	"eventText": `PermissionsRequestsToast__event-text-bf4df1`,
	"event-button": `PermissionsRequestsToast__event-button-aa686e`,
	"eventButton": `PermissionsRequestsToast__event-button-aa686e`,
	"enter": `PermissionsRequestsToast__enter-bbc6a3`,
	"enter-active": `PermissionsRequestsToast__enter-active-cb059a`,
	"enterActive": `PermissionsRequestsToast__enter-active-cb059a`,
	"exit": `PermissionsRequestsToast__exit-db98c2`,
	"exit-active": `PermissionsRequestsToast__exit-active-b133a3`,
	"exitActive": `PermissionsRequestsToast__exit-active-b133a3`
};
module.exports = ___CSS_LOADER_EXPORT___;
